import { ModelBase } from '../../core/model/model-base';
import { LocalDate } from '../../core/model/local-date';

export class PlannedMaintenanceAction extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      this.id = dataContext.id;
      this.plannedMaintenanceCaption = dataContext.plannedMaintenanceCaption;
      this.plannedMaintenanceInterval = dataContext.plannedMaintenanceInterval;
      this.latestMaintenanceExecution = dataContext.latestMaintenanceExecution;
    }
  }

  plannedMaintenanceCaption: string;
  plannedMaintenanceInterval: number;
  latestMaintenanceExecution: LocalDate;
}
